export const NotificationStoreDefinition = {
  state: {
    pendingNotifications: [],
    changes: 0,
    id: 0
  },
  mutations: {
    notificationAdd(state, notification) {
      state.pendingNotifications.push(Object.assign({}, notification, { id: state.id }));
      state.id++;
    },
    notificationRemove(state, id) {
      state.pendingNotifications = state.pendingNotifications.filter(notif => notif.id !== id);
    },
    notificationChange(state) {
      state.changes++;
    }
  },
  getters: {
    getNextNotification: (state) => () => {
      return state.pendingNotifications[0];
    },
  },
  actions: {
    createNotification({ commit }, notification) {
      commit(Mutations.add, notification);
      commit(Mutations.change);
    },
    removeNotification({ commit }, { id }) {
      commit(Mutations.remove, id);
      commit(Mutations.change);
    }
  },
};

export const NotificationActions = {
  createNotification: 'createNotification',
  removeNotification: 'removeNotification',
};

const Mutations = {
  add: 'notificationAdd',
  remove: 'notificationRemove',
  change: 'notificationChange',
};

export const NotificationsTypes = {
  success: 'success',
  error: 'error',
};
